module.exports = __webpack_public_path__ + "static/media/newsletter-img.b5946838.jpg";